
import * as ipxStaticRuntime$rQGIoAA2tz from '/home/runner/work/jbg-web/jbg-web/node_modules/@nuxt/image/dist/runtime/providers/ipxStatic'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipxStatic",
  "domains": [
    "jackboxgames.com",
    "jackbox.tv",
    "jackbox.studio"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 100
}

imageOptions.providers = {
  ['ipxStatic']: { provider: ipxStaticRuntime$rQGIoAA2tz, defaults: {} }
}
        